const { default: axios } = require('axios');
const { Dropzone } = require("dropzone");
import { min } from 'moment/moment';
import 'tippy.js/dist/tippy.css';

Dropzone.autoDiscover = false;

// myDropzone is null until the photos modal opens.
// window.initDropzone is called from the blade via Alpine $nextTick.
let myDropzone = null;

window.initDropzone = function () {
    if (myDropzone) return; // already initialised

    var formEl = document.getElementById('pre-project-image-form');
    if (!formEl) return;

    myDropzone = new Dropzone("#pre-project-image-form", {
        url: formEl.getAttribute('action_url'),
        autoProcessQueue: false,
        maxFilesize: 2,
        acceptedFiles: '.jpg,.jpeg',
        uploadMultiple: true,
        parallelUploads: 15,
        addRemoveLinks: false,
        maxFiles: 15,
        previewsContainer: '#preview',

        accept: function (file, done) {
            var reader = new FileReader();
            reader.onload = function (entry) {
                var image = new Image();
                image.onload = function () {
                    if (this.width >= 800 && this.height >= 600) {
                        done();
                    } else {
                        done("Invalid dimensions. Please upload at least 800×600 px.");
                    }
                };
                image.onerror = function () { done("Could not read image."); };
                image.src = entry.target.result;
            };
            reader.onerror = function () { done("Could not read file."); };
            reader.readAsDataURL(file);
            // done() is called only inside onload — never at the top level
        },

        init: async function () {
            var dz = this;
            dz.on("processing", function () {
                this.options.autoProcessQueue = true;
            });

            var pid = formEl.getAttribute('pre_project_id');
            try {
                var res = await axios.get('/api/map/get-pre-project-images/' + pid);
                var images = res.data.images || [];
                for (var i = 0; i < images.length; i++) {
                    var item = images[i];
                    var mockFile = { id: item.id, name: item.id, size: item.size, status: Dropzone.ADDED, url: item.image_path };
                    dz.emit("addedfile", mockFile);
                    dz.emit("thumbnail", mockFile, item.image_path);
                    dz.emit("complete", mockFile);
                    dz.files.push(mockFile);
                }
            } catch (e) {
                console.warn('Could not load existing images:', e);
            }
            $('#loading_images').hide();

            dz.on("sending", function () {
                var btn = document.getElementById('saveBtn');
                if (btn) { btn.textContent = 'Uploading…'; btn.disabled = true; }
            });
        },

        dictDefaultMessage: `<div class="relative flex items-center justify-center w-full h-64">
            <label class="flex flex-col items-center justify-center w-full h-full border-2 border-gray-300 border-dashed cursor-pointer bg-gray-50 hover:bg-gray-100">
                <div class="flex flex-col items-center justify-center pt-5 pb-6">
                    <svg class="mb-4 text-gray-500 w-14 h-14" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"/>
                    </svg>
                    <p class="mb-2 text-sm text-gray-500"><span class="text-2xl font-semibold">Click to upload or drop files here</span></p>
                    <ul class="list-disc px-8 text-center text-red-300 text-xs">
                        <li>Minimum 5 / maximum 15 images</li>
                        <li>JPEG or JPG only</li>
                        <li>Minimum resolution: 800×600 px</li>
                        <li>Maximum size: 2 MB each</li>
                    </ul>
                </div>
            </label>
        </div>`,

        previewTemplate: `<div class="dz-preview dz-error dz-complete dz-image-preview">
            <div class="dz-image"><img data-dz-thumbnail class="w-40 h-40"></div>
            <div class="dz-details"><div class="dz-size"><span data-dz-size></span></div></div>
            <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>
            <div class="dz-error-message"><span data-dz-errormessage></span></div>
            <a href="#" class="dz-remove" data-dz-remove><i class="fa fa-times"></i></a>
        </div>`,

        dictFallbackMessage: "Your browser does not support drag and drop file uploads.",
        dictFileTooBig: "File is too big ({{filesize}}MB). Max filesize: {{maxFilesize}}MB.",
        dictInvalidFileType: "Invalid file type.",
        dictResponseError: "Server responded with {{statusCode}} code.",
        dictCancelUpload: "Cancel upload",
        dictCancelUploadConfirmation: "Are you sure you want to cancel this upload?",
        dictRemoveFile: "Remove file",
        dictMaxFilesExceeded: "Max files exceeded.",
    });

    myDropzone.on("addedfile", function (file) {
        if (myDropzone.files.length > myDropzone.options.maxFiles) {
            myDropzone.removeFile(file);
            myDropzone.emit("maxfilesexceeded", file);
        }
        if (!file.id) { updatePhotoCount(); }
        validateByField('#pre_project_form','upload_images');
    });

    myDropzone.on("maxfilesexceeded", function () {
        $('#error_projects_images').text("No more files can be added.").addClass('text-red-400 py-4');
    });

    myDropzone.on("error", function (file, message) {
        if (message && message.errors && message.errors.file) {
            message = message.errors.file.toString();
        }
        myDropzone.removeFile(file);
        updatePhotoCount();
        $('#error_projects_images').text(message).addClass('text-red-400 py-4');
    });

    myDropzone.on("removedfile", function (file) {
        deletedImages.push(file.id);
        updatePhotoCount();
        $('#deleted_images').val(deletedImages.join(','));
        validateByField('#pre_project_form','upload_images');
    });
};

// ----------------------------------------------------------------
// Helpers
// ----------------------------------------------------------------
var deletedImages = [];

function updatePhotoCount() {

    $('#upload_images').val(myDropzone ? myDropzone.files.length : 0);

    var el = document.getElementById('photos');
    if (el) el.textContent = myDropzone ? myDropzone.files.length : 0;
}

// ----------------------------------------------------------------
// Upload images then submit the form via normal POST
// ----------------------------------------------------------------
function uploadPreProjectImages(form) {
    if (!myDropzone || myDropzone.files.length < 5) {
        $('#photos_error').text('Minimum 5 images required.');
        return;
    }
    if (myDropzone.files.length > myDropzone.options.maxFiles) {
        $('#photos_error').text('Maximum 15 images allowed.');
        return;
    }
    $('#photos_error').text('');

    var btn = document.getElementById('saveBtn');
    btn.disabled = true;
    btn.textContent = 'Submitting…';

    myDropzone.off("successmultiple");
    myDropzone.off("errormultiple");

    myDropzone.on("successmultiple", function () {
        btn.disabled = false;
        btn.textContent = 'Submit';
        form.submit();
    });

    myDropzone.on("errormultiple", function (files, message) {
        $('#photos_error').text(typeof message === 'string' ? message : 'Upload failed.');
        btn.disabled = false;
        btn.textContent = 'Submit';
    });

    if (myDropzone.getQueuedFiles().length > 0) {
        myDropzone.processQueue();
    } else {
        btn.disabled = false;
        btn.textContent = 'Submit';
        form.submit();
    }
}

document.addEventListener('upload:pre_project_brochure', (event) => {
    if (event.detail.count) {
        $('#project_broucher_field').val(event.detail.count);
    } else {
        $('#project_broucher_field').val('');
    }
    validateByField('#pre_project_form','broucher');
})


document.addEventListener('upload:pre_project_floor_plan', (event) => {
    if (event.detail.count) {
        $('#floor_plans_field').val(event.detail.count);
    } else {
        $('#floor_plans_field').val('');
    }
    validateByField('#pre_project_form','floor_plans');
})

var paymentBreakDown = [];

window.addEventListener('payment_breakdown_payload', (event) => {
    paymentBreakDown = event.detail;
})


if ($('#pre_project_form').length) {
    const validator = $('#pre_project_form').validate({
        ignore: "[name='latitude'],[name='longitude']",

        // ignore: [], //forcing to validate hidden field as well
        rules: {
            'amenities[]': {
                required: true, //!$('.checkedBox:checked').length,
                minlength: 4
            },
            price: {
                required: () => {
                    return $('#project_price').prop('required');
                },
            },
            project_pin: {
                required: true,
            },
            project_type: {
                required: true,
            },
            latitude: {
                required: true
            },
            upload_images: {
                required: true,
                min: 5,
                max: 15
            },
            longitude: {
                required: true
            },
            project_min_beds: {
                required: function () {
                    return $('#project_min_beds').prop('required'); // if project type is not plot then validate it.
                }
            },
            project_max_beds: {
                required: function () {
                    return $('#project_max_beds').prop('required'); // if project type is not plot then validate it.
                }
            },
            new_description: {
                required: true,
                minlength: 751,
                maxlength: 3000
            },
            sum_plan: {
                required: true,
                min: 100,
                max: 100
            },

            post_completion_month: {
                required: function (element) {
                    var val = parseInt($("#post_completion").val());
                    return !isNaN(val) && val > 0;
                },
                min: function (element) {
                    var val = parseInt($("#post_completion").val());
                    return (!isNaN(val) && val > 0) ? 1 : false;
                }
            },
            expected_annual_service_fees: {
                required: true,
                digits: false
            },
            booking_amount_in_percentage: {
                required: true,
            },
            total_floors: {
                required: true,
            },
            total_units: {
                required: true,
            },

            floor_plans: {
                required: true,
            },
            city_id: {
                required: true,
            },
            region_id: {
                required: true,
            },
            broucher: {
                required: true,
            },
            permit_number: {
                required: function () {
                    return $('#pre_qrcode_images_count').val() > 0;
                }
            },
            qrcode_images_count: {
                required: function () {
                    return $('#permit_number').val().trim() !== '';
                },
                min: function () {
                    return $('#permit_number').val().trim() !== '' ? 1 : 0
                }
            },

            total_breakdown_percentage: {
                required: true,
                min: 100,
                max: 100
            },
            paymentPlanPercentageField: {
                required: true,
                min: 1
            }

        },
        messages: {
            sum_plan: {
                min: 'Sum of payment percentages must total 100%',
                max: 'Sum of payment percentages must total 100%',

            },
            total_breakdown_percentage: {
                required: 'All Fields are required',
                min: 'Sum of payment breakdown must total 100%',
                max: 'Sum of payment breakdown must total 100%',

            },
            qrcode_images_count: {
                required: 'This field is required',
                min: 'This field is required',

            },
            upload_images: {

                min: 'Minimum 5 images required.',
                max: 'Maximum 15 images allowed.',

            },
            price: {
                required: 'This field is required',
            },
            city_id: {
                required: 'This field is required',
            },
            'amenities[]': {
                minlength: 'The amenities must be at least 4 characters.'
            },
            new_description: {
                required: 'This field is required',
                minlength: 'The description must be at least 750 characters.',
                maxlength: 'The description must not be more than 3000 characters.'
            },
            project_min_beds: {
                required: 'This field is required',
            },
            project_max_beds: {
                required: 'This field is required',
            },
            floor_plans: {
                required: 'This field is required',
            },
            paymentPlanPercentageField: {
                required: 'This field is required',
                min: 'This field is required'
            }
        },
        errorPlacement: function (error, element) {
            let lat = element.attr("name") == 'latitude' && element.val() == '';
            let project_min_beds = element.attr("name") == 'project_min_beds';
            let project_type = element.attr("name") == 'project_type';

            let amenities = element.attr("name") == 'amenities[]';
            let breakdown = element.attr("name").startsWith('breakdown[');

            let project_max_beds = element.attr("name") == 'project_max_beds';
            let region_id = element.attr("name") == 'region_id';
            let floor_plans = element.attr("name") == 'floor_plans';
            let broucher = element.attr("name") == 'broucher';
            let total_breakdown_percentage = element.attr("name") == 'total_breakdown_percentage';
            if (lat) {
                error.appendTo("#lat_long_error");
            } else if (project_type) {
                error.appendTo("#project_type-error");

            } else if (amenities) {
                error.appendTo("#amenities_error");
            } else if (project_min_beds) {
                $("#project_min_beds_error").empty();
                error.appendTo("#project_min_beds_error");
            } else if (breakdown) {
                error.appendTo("#bd-error");
            } else if (project_max_beds) {
                $("#project_max_beds_error").empty();
                error.appendTo("#project_max_beds_error");
            } else if (element.attr('name') == ('project_pin')) {
                error.appendTo("#project_pin_error");
            } else if (element.attr("name") == 'during_construction') {
                error.appendTo("#during_construction-error");
            } else if (element.attr("name") == 'post_completion_month') {
                error.appendTo("#post_completion_month-error");
            } else if (element.attr("name") == 'type') {
                error.appendTo("#type-error");
            }
            else if (floor_plans) {
                error.appendTo("#floor_plans-error");
            }
            else if (broucher) {
                error.appendTo("#project_broucher-error");
            }
            else if (region_id) {
                error.appendTo("#regionId-error");
            }else if (total_breakdown_percentage) {
                error.appendTo("#total_breakdown_percentage-error");
            } else if (element.attr("name") == 'new_description') {
                error.appendTo("#new_description-error");

            } else if (element.attr("name") == 'qrcode_images_count') {
                error.appendTo("#next_pre_qrcode_error");
            } else if (element.attr("name") == 'permit_number') {
                error.appendTo("#permit_number-ui-error");
            }
            else {
                error.insertAfter(element);
            }
        },
        highlight: function (element) {
            $(element).addClass("border-red-900 shake");

            // Remove class after animation so it can be reused
            setTimeout(() => {
                $(element).removeClass("border-red-900 shake");
            }, 300);
        },
        submitHandler: async (form, event) => {
            event.preventDefault();

            if (!myDropzone || myDropzone.files.length < 5) {
                $('#photos_error').text('Minimum 5 images required.');
                return;
            }
            if (myDropzone.files.length > myDropzone.options.maxFiles) {
                $('#photos_error').text('Maximum 15 images allowed.');
                return;
            }
            $('#photos_error').text('');


            // if (myDropzone.files.length > myDropzone.options.maxFiles) {

            //     $('#pre_photos_error').text('Maximuim 15 images')
            //     return;
            // }
            // if (myDropzone.files.length < 5) {

            //     $('#pre_photos_error').text('Minimum 5 images required')
            //     return;
            // }

            // if ($('#permit_number').val() && $('#qrcode_images_count').val() != 1) {

            //     $('#pre_qrcode_error').text('QR Code required');
            //     return;
            // }
            // else {

            //     $('#pre_qrcode_error').text('');
            // }


            var formData = $(form).serializeArray();
            formData = formData.filter(function (field) {
                return !field.name.startsWith("breakdown[");
            });

            var formDataObject = {};

            formDataObject['breakdown'] = paymentBreakDown;



            formData.forEach(function (field) {
                if (field.name.endsWith('[]')) {
                    // Remove the [] from the name to standardize the key
                    var key = field.name.slice(0, -2);
                    if (!formDataObject[key]) {
                        formDataObject[key] = [];
                    }
                    formDataObject[key].push(field.value);
                } else {
                    formDataObject[field.name] = field.value;
                }
            });
            if (myDropzone.getQueuedFiles().length > 0) {
                await myDropzone.processQueue(); // Manually start the upload process
                await myDropzone.on("successmultiple", async () => {
                    document.querySelector('#saveBtn').innerHTML = "Save";
                    document.querySelector('#saveBtn').removeAttribute('disabled');
                    // Hide the total progress bar when all uploads are completed
                    await saveData(form, formDataObject);
                })
                await myDropzone.on("error", async (file, message) => {
                    if (message && typeof message === 'object' && 'message' in message) {
                        $('#photos_error').text(message.message);
                        document.querySelector('#saveBtn').innerHTML = "Save";
                        document.querySelector('#saveBtn').removeAttribute('disabled');
                    }

                })
            } else {
                await saveData(form, formDataObject);
            }

            function saveData(form, formDataObject) {
                document.querySelector('#saveBtn').innerHTML = "Saving...";
                document.querySelector('#saveBtn').setAttribute('disabled');

                axios.post($(form).attr('action'), formDataObject, {
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                    }
                }).then((res) => {
                    Livewire.emit('alert', { 'message': res.data.message, 'type': 'success', 'html': false })
                    window.location.href = res.data.redirect;
                }).catch(error => {
                    if (error.status === 422) {
                        let serverErrors = error.response.data.errors;
                        let formattedErrors = {};

                        Object.keys(serverErrors).forEach(function (field) {
                            // jQuery Validate only accepts a single message
                            formattedErrors[field] = serverErrors[field][0];
                        });
                        console.log(formattedErrors);

                        // Display errors using jQuery Validation
                        validator.showErrors(formattedErrors);
                    }
                    console.log(error);
                }).finally(() => {
                    document.querySelector('#saveBtn').innerHTML = "Save";
                    document.querySelector('#saveBtn').removeAttribute('disabled');
                })
            }
            return false;
        }
    });
}
